import React, { useContext, useEffect, useState } from "react";
import BaseWrapper from "../../components/ui/BaseWrapper";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import {
  brandFontFamily,
  brandInputTextColor,
  brandPrimaryColor,
} from "../../utils/variables";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "../../routes";
import { LayoutContext } from "../../context/LayoutContext";
import { useQuery } from "@tanstack/react-query";
import { me } from "../../services/api/user";
import useAuth from "../../hooks/useAuth";
import CompanySettingsHeader from "./Settings/components/CompanySettingsHeader";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const CustomTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    [theme.breakpoints.up("sm")]: {
      minWidth: 0,
    },
    height: "3px",
    width: "230px",
    fontWeight: 300,
    fontSize: "16px",
    boxShadow: "0px -1px 8px 0px rgba(0, 0, 0, 0.09)",

    borderRadius: "6px",
    // padding: 0,
    margin: "13px 0",
    background: "white",
    marginRight: theme.spacing(1),
    color: brandInputTextColor,
    fontFamily: brandFontFamily,
    "&:hover": {
      /* color: "#40a9ff",
          opacity: 1, */
    },
    "&.Mui-selected": {
      color: brandPrimaryColor,
      fontWeight: 400,
      borderBottom: `1px solid ${brandPrimaryColor}`,
    },
    "&.Mui-focusVisible": {
      //   backgroundColor: "#d1eaff",
    },
  })
);

const CompanySettings = () => {
  const { isBannerVisible } = useContext(LayoutContext);
  const [value, setValue] = useState(0);
  const { authRole, auth } = useAuth();
  const isCompanyOwner = auth?.user?.company?.ownerId === auth?.user?.id;
  const location = useLocation();
  const navigate = useNavigate();

  const {
    isPending: isUserLoading,
    error: isUserError,
    data: userData,
    refetch: refetchMe,
  } = useQuery({
    queryKey: ["userData"],
    queryFn: me,
    retry: 2,
  });

  const userProfileSettingsRoute = routes.find(
    (route) => route.path === "/company"
  );

  const allTabs = userProfileSettingsRoute?.childs || [];
  const visibleTabs = allTabs.filter(
    (tab) => tab?.roles?.includes(authRole) && (!tab.ownerOnly || isCompanyOwner)
  );

  useEffect(() => {
    const currentTabIndex = visibleTabs?.findIndex((tab) =>
      location.pathname.endsWith(`/company/${tab.path}`)
    );

    if (currentTabIndex !== -1) {
      setValue(currentTabIndex);
    }
  }, [location.pathname, visibleTabs]);

  const handleChange = (event, newValue) => {
    const selectedTab = visibleTabs[newValue];

    navigate(`/company/${selectedTab.path}`);
    setValue(newValue);
  };

  return (
    <div className="bg-light h-full">
      <div
        className={`bg-light sm:fixed 2xl:w-[95.2%] xl:w-[93.2%] lg:w-[90.6%] md:w-[87.5%] sm:w-[95%] w-full h-screen transition-all ${
          isBannerVisible ? "top-[106px]" : "top-[56px]"
        }`}
      >
        <CompanySettingsHeader />
        <BaseWrapper>
          {visibleTabs.length > 1 && (
          <Tabs
            TabIndicatorProps={{
              style: {
                display: "none", // Hide the indicator
              },
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{
              // The global `.MuiTabs-flexContainer` overflow rule can add a second
              // scrollbar inside the scrollable variant - let MUI own it.
              "& .MuiTabs-flexContainer": { overflow: "visible !important" },
              // A disabled scroll button still reserves width, which indents the
              // first tab away from the page edge.
              "& .MuiTabs-scrollButtons.Mui-disabled": { width: 0, opacity: 0 },
            }}
          >
            {visibleTabs?.map(
              (tab, index) =>
                tab?.roles.includes(authRole) && (
                  <CustomTab
                    key={index}
                    label={tab.text}
                    {...a11yProps(index)}
                    sx={{
                      minHeight: "38px",
                      marginRight: "40px",
                    }}
                  />
                )
            )}
          </Tabs>
          )}

          {visibleTabs?.map((tab, index) => {
            if (!tab?.roles?.includes(authRole)) return null;
            return (
              <CustomTabPanel value={value} index={index} key={index}>
                {React.cloneElement(tab.component, {
                  user: userData,
                  refetchMe,
                })}
              </CustomTabPanel>
            );
          })}
        </BaseWrapper>
      </div>
    </div>
  );
};

export default CompanySettings;
